import useStore from 'store';

type Serie = {
  data: number[][];
  serieType: 'index' | 'security';
  colorIndex: number;
  id: any;
  metric: string;
  name: string;
};

const useSeries = () => {
  const store = useStore(state => ({
    priceHistory: state.priceHistory,
    realTime: state.realTime,
    chartState: state.chartState,
    index: state.index,
  }));

  const selected = store.chartState.getSeries().selected.filter(s => !!s.value);

  const rawSeries = selected
    .filter(option => !!store.priceHistory.results[option.value])
    .map(({ type, ...option }) => {
      const data = store.priceHistory.results[option.value][option.metric] || [];

      return {
        name: option.label,
        id: option.value,
        metric: option.metric,
        colorIndex: option.colorIndex,
        data,
        serieType: type as Serie['serieType'],
      };
    });

  const series = normalizeData(rawSeries);

  return series;
};

const normalizeData = (series: Serie[]): Serie[] => {
  const minDate = Math.max(
    ...series.map(serie => (serie.data && serie.data.length ? serie.data[0][0] : 0))
  );

  return series.map(serie => {
    const data = serie.data.filter(([date]) => date >= minDate);

    return {
      ...serie,
      data,
    };
  });
};

export default useSeries;
